import { MapBuildingSchema, MapBuildingSchemaResponseWrapper } from "./types";
import fetcher from "../../../lib/fetcher";
import { MapItem } from "../../../components/ui/map/itemYmap";
import useSWRMutation from "swr/mutation";

const ERROR_MESSAGE = "Не удалось получить данные";

const useMapList = <T extends boolean | undefined = undefined>(
  isTransform?: T
) => {
  async function fetchMapList(
    url: string,
    { arg }: { arg: { typeIds: number[] } }
  ) {
    try {
      const data = await fetcher.swr<MapBuildingSchemaResponseWrapper>(url, {
        method: "POST",
        data: { typeIds: arg.typeIds.length ? arg.typeIds : undefined },
      });
      return data.data as MapBuildingSchema[];
    } catch (error) {
      throw ERROR_MESSAGE;
    }
  }

  const { data, error, isMutating, trigger } = useSWRMutation(
    `/building/map-data`,
    fetchMapList
  );

  const transformList = (): MapItem[] => {
    return data?.map((mapItem) => {
      return {
        id: mapItem.id,
        selected: false,
        coords: [mapItem.coordinates.latitude, mapItem.coordinates.longitude],
      };
    }) as MapItem[];
  };

  const transformed = isTransform ? transformList() ?? [] : data ?? [];

  type TMapList = T extends true ? MapItem[] : MapBuildingSchema[];

  return {
    data: transformed as TMapList,
    error,
    isMutating,
    trigger,
  };
};

export default useMapList;
